import { Button } from "../components/ui/button";
import { Check } from "lucide-react";
import kundliMockup from "../../../assets/images/kundali-matching/report-book.jpg";

const Hero = () => {

  const handleScrollToPricing = () => {
    const element = document.getElementById("pricing-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="min-h-screen mt-[80px] bg-gradient-to-br from-secondary_km to-accent_km relative overflow-hidden">
      <div className="container mx-auto px-4 py-8 md:py-16 relative z-10">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6 md:space-y-8 text-center lg:text-left">
            <div className="space-y-3 md:space-y-4">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
                Are You a Match Made in Heaven? <br />
                <span className="text-3xl text-accent-foreground_km">
                  Verify Now!
                </span>
              </h1>
              
              <p className="text-lg md:text-xl text-white/90 leading-relaxed">
                Get a Premium Kundali Matching Report with clear insights on Love, Emotional, Mental and Physical Compatibility — all delivered in an easy-to-read report.
              </p>
              <p className="text-lg md:text-xl text-white/90 font-bold text-accent-foreground">Limited-time offer: ₹1050 <span className="line-through opacity-80">₹1,996</span></p>
              <p className="text-base md:text-lg text-white/80">
                You will receive your Premium Kundli Matching Report online i.e, in e-book format in 2 
                working days.
              </p>
            </div>

            {/* Benefits */}
            <div className="space-y-3 md:space-y-4">
              <div className="flex items-center space-x-3 justify-center lg:justify-start">
                <div className="bg-white/20 rounded-full p-2">
                  <Check className="h-4 w-4 md:h-5 md:w-5 text-white" />
                </div>
                <div className="text-white text-left">
                  <span className="font-bold text-lg md:text-xl">1.2 lakh+</span>
                  <p className="text-white/90 text-sm md:text-base">Join over <strong>1.2 lakh satisfied couples</strong> who trust Acharya Lav Bhushan for guidance</p>
                </div>
              </div>
              

            </div>

            {/* CTA Button */}
            <Button 
              variant="astrology" 
              size="xl" 
              className="shadow_km-2xl w-full sm:w-auto text-base md:text-lg px-6 md:px-10 py-3 md:py-4"
              onClick={handleScrollToPricing}
            >
              Get Your Premium Report Now
            </Button>
          </div>

          {/* Right Content - Kundli Report Image */}
          <div className="flex justify-center lg:justify-end order-first lg:order-last">
            <div className="relative w-full max-w-sm md:max-w-md">
              <img 
                src={kundliMockup} 
                alt="Premium Personalized Kundli Report"
                className="w-full h-auto drop-shadow-2xl transform transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-accent/30 to-transparent rounded-lg -z-10 blur-xl scale-110"></div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-48 h-48 md:w-96 md:h-96 bg-white/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-32 h-32 md:w-64 md:h-64 bg-accent/20 rounded-full blur-2xl"></div>
    </section>
  );
};

export default Hero;